import React, { useRef, useState, useEffect } from 'react';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import InputField from '@ingka/input-field';
import RadioButtonGroup from '@ingka/radio-button-group';
import './product.scss';
import Button from '@ingka/button';
import Accordion, { AccordionItem } from '@ingka/accordion';
import '@ingka/svg-icon/style.scss';
import '@ingka/accordion/style.scss';
import '@ingka/focus/style.scss';
import DatePickerComponent from 'pages/DatePickerComponent/datePickerComponent';

const Products = (props: any) => {
  const { productRows, setProductRows } = props;
  const [previousRows, setPreviousRows] = useState([]);

  const handleDeleteRow = (index) => {
    const newPreviousRows = previousRows.filter((_, i) => i !== index);
    // setPreviousRows(newPreviousRows);
  };

  const handleInputChange = (index: number, field: any, value: any) => {
    if (field === 'validFor' && value instanceof Date) {
      value = value.toISOString();
    }
    if (field === 'harvestValidUntil' && value instanceof Date) {
      value = value.toISOString();
    }
    const newFormRows = productRows?.map((row: any, i: any) =>
      i === index ? { ...row, [field]: value } : row
    );
    setProductRows([...newFormRows]);
  };

  return (
    <div>
      <div className="maindiv" style={{ height: 'auto' }}>
        {productRows?.map((row, index) => (
          <div className="product-tabs" key={index}>
            <InputField
              style={{ marginRight: 10 }}
              iconPosition="leading"
              id={`article-number-${index}`}
              type="text"
              value={row.gtin}
              onChange={(e) => handleInputChange(index, 'gtin', e.target.value)}
              label={index === 0 ? 'GTIN' : ''}
            />
            <InputField
              // style={{ marginRight: 10 }}
              iconPosition="leading"
              id={`item-supplier${index}`}
              type="text"
              value={row.itemSupplier}
              onChange={(e) => handleInputChange(index, 'itemSupplier', e.target.value)}
              label={index === 0 ? 'Item Supplier' : ''}
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <DatePickerComponent
                heading="Valid for Batches from"
                selectedDate={row.validFor ? new Date(row.validFor) : null}
                onChange={(formattedDate) => handleInputChange(index, 'validFor', formattedDate)}
                format="iso"
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <DatePickerComponent
                heading="Valid for Batches until"
                selectedDate={row.validUntil ? new Date(row.validUntil) : null}
                onChange={(formattedDate) => handleInputChange(index, 'validUntil', formattedDate)}
                format="iso"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
